<template>
  <div class="modalback">
    <div class="modalcontent container">
      <div class="row pt-3">
        <div class="col">
          <div class="d-flex flex-column">
            <p class="text-light">{{ this.$store.state.inputTextProp.title }}</p>
            <input
              type="text"
              v-model="inputText"
            />
            <div class="d-flex flex-row mt-3 justify-content-center gap-2">
              <button class="border-0 rounded-4" style="margin:10px;width:100px" v-on:click="cancelAction">Cancel</button>
              <button class="acry-btn" style="width:100px" v-on:click="okAction">OK</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "InputTextDialog",
  props: {},
  data: function () {
    return {
      inputText: "",
    };
  },
  created(){
    this.inputText = this.$store.state.inputTextProp.value
  },
  mounted: function () {},
  methods: {
    okAction() {
      this.$store.state.inputTextProp.callback(this.inputText);
      this.$store.commit("hideInputText");
    },
    cancelAction() {
      this.$store.commit("hideInputText");
    },
  },
  watch: {},
  components: {},
  computed: {},
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.scroll {
  overflow-y: scroll;
}
.modalback {
  z-index: 200;

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);

  display: flex;
  align-items: center;
  justify-content: center;
}
.modalcontent {
  z-index: 201;
  width: 300px;
  height: 200px;
  padding: 1em;
  background-color: rgb(85, 82, 82);
  border: 3px solid rgb(215, 215, 215);
}
</style>
